import clientConfig from '../client/config';

export const TRAINER_IMAGE = `${clientConfig.imageServiceUrl}trainer-no-branding_web.jpg`;
export const DEFAULT_TEAM_IMAGE = `${clientConfig.imageServiceUrl}default-team-image.jpg?template=size194w`;
